import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    /* http://meyerweb.com/eric/tools/css/reset/ 
    v2.0 | 20110126
    License: none (public domain)
    */

    html, body, div, span, applet, object, iframe,
    h1, h2, h3, h4, h5, h6, p, blockquote, pre,
    a, abbr, acronym, address, big, cite, code,
    del, dfn, em, img, ins, kbd, q, s, samp,
    small, strike, strong, sub, sup, tt, var, textarea,
    b, u, i, center,
    dl, dt, dd, ol, ul, li,
    fieldset, form, label, legend,
    table, caption, tbody, tfoot, thead, tr, th, td,
    article, aside, canvas, details, embed, 
    figure, figcaption, footer, header, hgroup, 
    menu, nav, output, ruby, section, summary,
    time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font-family: 'Roboto', sans-serif;
    vertical-align: baseline;
    }
    /* HTML5 display-role reset for older browsers */
    article, aside, details, figcaption, figure, 
    footer, header, hgroup, menu, nav, section {
    display: block;
    }
    
    body {
    line-height: 1;
    font-family: Roboto, sans-serif;
    color: #000000;
    background-image: linear-gradient(to top, #4D65A8,#6D7CE4);
    ::-webkit-scrollbar {
        width: 8px;               
        }

    ::-webkit-scrollbar-track {
        background: #6D7CE4;        
    }

    ::-webkit-scrollbar-thumb {
        background-color: #31416e;    
        border-radius: 20px;       
        border: 3px solid #31416e;  
     }
    }
    ol, ul {
    list-style: none;
    }
    blockquote, q {
    quotes: none;
    }
    blockquote:before, blockquote:after,
    q:before, q:after {
    content: '';
    content: none;
    }
    table {
    border-collapse: collapse;
    border-spacing: 0;
    }
    *{
        box-sizing: border-box;
        font-family: 'Roboto', sans-serif;
    }
    button{
        border: none;
        font-family: 'Roboto', sans-serif;
    }
    strong { font-weight: bold}
    a, :link{
        text-decoration: none;
        color: inherit;
        cursor: pointer;
    }
`;
export default GlobalStyle;
